export const namespaced = true;

import ProductService from '@/services/ProductService.js';

export const state = {
  products: [],
};

export const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
};

export const actions = {
  fetchProducts({ commit }) {
    return ProductService.all().then((response) => {
      commit('SET_PRODUCTS', response.data);
    });
  },
};

export const getters = {};
